define(function (require) {
    var $ = require("jquery");
    var ko = require("knockout");
    require("openclose");

    ko.bindingHandlers.dpOpenClose = {
        init: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
            $(element).dpOpenClose({
                opener: ".ko-opener",
                classOpened: "is-open",
                contentBlock: ".ko-content",
                duration: 300 // ms
            });
        }
    };
});
